import { create } from "zustand"

export type ActivityMeta = {
    cid: string
    game: string
    template: string
    tasks: {
        cid: string
        order: number
        template: string
        templateParams: Record<string, unknown> | null
    }[]
}

export enum GlobalStage {
    LOADING,
    HOME,
    MAIN_GAME,
}

interface States {
    player: null | {
        state: {
            avatar: string | null
            isRecallUser: boolean
        }
        collection: null | Record<string, { key: string; ts: number }[] | null>
    }
    meta: ActivityMeta | null
    globalStage: GlobalStage
    topLayerActive: boolean
}
interface Actions {
    setPlayer: (payload: States["player"]) => void
    setMeta: (payload: ActivityMeta) => void
    setGlobalStage: (payload: States["globalStage"]) => void
    setTopLayerActive: (active: boolean) => void
}

export const useGlobalStore = create<States & Actions>((set) => ({
    player: null,
    setPlayer: (payload) => {
        set({ player: payload })
    },
    meta: null,
    setMeta: (payload) => {
        set({ meta: payload })
    },
    globalStage: GlobalStage.LOADING,
    setGlobalStage: (payload) => {
        set({ globalStage: payload })
    },
    topLayerActive: false,
    setTopLayerActive: (active) => {
        set({ topLayerActive: active })
    },
}))
